import { render, staticRenderFns } from "./KeyvetFooter.vue?vue&type=template&id=d5ada4e8&scoped=true&"
var script = {}
import style0 from "./KeyvetFooter.vue?vue&type=style&index=0&id=d5ada4e8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5ada4e8",
  null
  
)

export default component.exports